/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphAreaStackedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Area Stacked',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30.371 16.321 34 23.578v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-15l10 12 3.584-5.378a.5.5 0 0 1 .832 0L20 29.578l9.517-13.324a.5.5 0 0 1 .854.067Z"
    />
    <path
      d="m11.769 25.239 2.151-3.227a2.5 2.5 0 0 1 4.16 0L20.074 25l7.906-11.067a2.5 2.5 0 0 1 4.271.335L34 17.765V7.578l-3.57-5.355a.5.5 0 0 0-.84.012L20 17.578 16.416 12.2a.5.5 0 0 0-.832 0L12 17.578l-10-10v5.938Z"
    />
  </svg>`;
};
